export enum ColumnPosition {
    Left,
    Right
}
